import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface AuthorLinkDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  authorSearch: string;
  setAuthorSearch: (value: string) => void;
  authors: any[];
  authorDropdown: boolean;
  setAuthorDropdown: (open: boolean) => void;
  setAuthorValue: (id: number) => void;
  authorValue: number | null;
  onSearch: (value: string) => void;
  onConfirm: () => void;
}

const AuthorLinkDialog: React.FC<AuthorLinkDialogProps> = ({
  open,
  onOpenChange,
  authorSearch,
  setAuthorSearch,
  authors,
  authorDropdown,
  setAuthorDropdown,
  setAuthorValue,
  authorValue,
  onSearch,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Müəllifi seç</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div className="relative">
          <Input
            placeholder="Müəllifi axtarın"
            value={authorSearch}
            onChange={(e) => onSearch(e.target.value)}
            onFocus={() => authors.length > 0 && setAuthorDropdown(true)}
            onBlur={() => setTimeout(() => setAuthorDropdown(false), 150)}
          />
          {authorDropdown && authors.length > 0 && (
            <div className="absolute z-50 w-full mt-1 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg overflow-hidden max-h-52 overflow-y-auto">
              {authors.map((a: any) => (
                <button
                  key={a.id}
                  type="button"
                  className="w-full px-3 py-2.5 text-left text-sm hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                  onClick={() => {
                    setAuthorValue(a.id);
                    setAuthorSearch(a.fullname);
                    setAuthorDropdown(false);
                  }}
                >
                  {a.fullname}
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Ləğv et</Button>
          <Button onClick={onConfirm} disabled={!authorValue}>Təsdiqlə</Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default AuthorLinkDialog;
